module.exports = __webpack_public_path__ + "static/Impact_1_2-965c3575af455d25d18b0f4eed474238.svg";